import axios from 'axios';
import { useToast } from './useToast';

const API = process.env.REACT_APP_API_URL;

/**
 * useSoftDelete — delete→undo-toast→restore plumbing shared by any page whose
 * entity has a recycle-bin endpoint (program/component/goal/client/...).
 *
 * const { toast, dismissToast, restore, deleteWithUndo } = useSoftDelete('program', fetchPrograms);
 *
 * restore(item)              — POST /recycle-bin/{entityType}/{item.id}/restore, then refetch
 * deleteWithUndo(item, label, deleteFn) — runs deleteFn() (your axios.delete/delete-with-reparent
 *   call), then shows an "Undo" toast wired to restore(item), then refetches. Rejects if deleteFn
 *   rejects — catch at the call site same as before.
 */
export function useSoftDelete(entityType, refetch) {
  const { toast, showToast, dismissToast } = useToast();

  const restore = (item) => axios.post(`${API}/recycle-bin/${entityType}/${item.id}/restore`)
    .then(() => refetch())
    .catch(err => alert('Restore failed: ' + (err.response?.data?.detail?.message || err.response?.data?.detail || err.message)));

  const deleteWithUndo = async (item, label, deleteFn) => {
    await deleteFn();
    showToast(`Deleted "${label}".`, { actionLabel: 'Undo', onAction: () => restore(item) });
    refetch();
  };

  return { toast, dismissToast, restore, deleteWithUndo };
}
